module.exports = __webpack_public_path__ + "static/coritycasestudy-70c09bfdbf3e99af16512b6af45a2dbc.png";